var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 8L5 6.2L6.8 8L7.5 7.3L5.7 5.5L7.5 3.7L6.8 3L5 4.8L3.2 3L2.5 3.7L4.3 5.5L2.5 7.3L3.2 8ZM5 10.5C4.30833 10.5 3.65833 10.3687 3.05 10.106C2.44167 9.84367 1.9125 9.4875 1.4625 9.0375C1.0125 8.5875 0.656333 8.05833 0.394 7.45C0.131333 6.84167 0 6.19167 0 5.5C0 4.80833 0.131333 4.15833 0.394 3.55C0.656333 2.94167 1.0125 2.4125 1.4625 1.9625C1.9125 1.5125 2.44167 1.15617 3.05 0.8935C3.65833 0.631167 4.30833 0.5 5 0.5C5.69167 0.5 6.34167 0.631167 6.95 0.8935C7.55833 1.15617 8.0875 1.5125 8.5375 1.9625C8.9875 2.4125 9.34367 2.94167 9.606 3.55C9.86867 4.15833 10 4.80833 10 5.5C10 6.19167 9.86867 6.84167 9.606 7.45C9.34367 8.05833 8.9875 8.5875 8.5375 9.0375C8.0875 9.4875 7.55833 9.84367 6.95 10.106C6.34167 10.3687 5.69167 10.5 5 10.5Z",
    fill: "#B8170D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.9062adfc95ecf77ead922c7d5c9af118.svg";
export { ForwardRef as ReactComponent };